import { writable } from "svelte/store";

import type { MediaObj } from "@shared/types/Media";

export type ActionBarStore = {
  loaded: boolean;
  failed: boolean;
  data: ActionBarData;
};

export type ActionBarData = {
  id?: number;
  description: string;
  image_upload_id?: number;
  image_upload?: MediaObj;
};

const initialActionBarStore: ActionBarStore = {
  loaded: false,
  failed: false,
  data: {
    description: null,
    image_upload: {
      id: null,
      cloudinary_image_url: null,
    },
  },
};

export const actionBarStore = writable<ActionBarStore>(initialActionBarStore);
